import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

const startApp = () => {
  // Debug: Check Cordova and plugin availability
  console.log('=== CORDOVA DEBUG ===');
  console.log('Cordova available:', !!window.cordova);
  console.log('Camera plugin available:', !!window.navigator.camera);
  console.log('Geolocation available:', !!window.navigator.geolocation);
  console.log('Device ready:', true);
  console.log('====================');
  
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
};

if (window.cordova) {
  document.addEventListener('deviceready', startApp, false);
} else {
  console.warn('Cordova not detected - running in browser mode');
  startApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
